import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import Const from 'constants';
import {isPlayerUsedInLineups} from 'components/organisms/used-players-list/helpers';

class FilterLineupsByPlayerAndFlex extends Component {
    onCheck(isChecked) {
        const {player, filterPosition} = this.props;

        let lineupRoles = [Const.OVERALL_MODE, 'FLEX', 'S-FLEX', 'Super FLEX', 'UTIL'];

        isChecked &&
            filterPosition.isKeyFlex() &&
            player.usedLineupsCount > player.usedInLineupsAsFlex && //if a player does not occupy the flex position then search on flex only
            (lineupRoles = ['FLEX', 'UTIL']);

        isChecked &&
            filterPosition.isKeySuperFlex() &&
            player.usedLineupsCount > player.usedInLineupsAsSuperFlex && //if a player does not occupy the super flex position then search on flex only
            (lineupRoles = ['S-FLEX', 'Super FLEX']);

        this.props.dispatch(
            Action.do('filterLineupsByCheckedPlayer', {
                playerId: player.getId(),
                isChecked,
                lineupRoles,
            }),
        );
    }

    isPlayerChecked() {
        const {player, filterLineupsByPlayer, filterPosition} = this.props;

        let lineupRoles = [Const.OVERALL_MODE, 'FLEX', 'S-FLEX', 'Super FLEX', 'UTIL'];
        filterPosition.isKeyFlex() && (lineupRoles = ['FLEX', 'UTIL']);
        filterPosition.isKeySuperFlex() && (lineupRoles = ['S-FLEX', 'Super FLEX']);

        return filterLineupsByPlayer.isPlayerCheckedOnLineupRoles(player.getId(), lineupRoles);
    }

    canComponentBeRendered() {
        const {lineupPlayerMap} = this.props;

        return lineupPlayerMap.hasMap();
    }

    getClassNames(isPlayerChecked, isButtonDisabled) {
        const classNames = ['search-btn', this.props.className || ''];

        if (isPlayerChecked && !isButtonDisabled) {
            classNames.push('active');
        }

        return classNames;
    }

    getTitle(isChecked) {
        return isChecked ? 'Search enabled' : 'Search disabled';
    }

    isButtonDisabled() {
        const {player, filterPosition} = this.props;

        return !isPlayerUsedInLineups(player, filterPosition);
    }

    render() {
        if (!this.canComponentBeRendered()) {
            return null;
        }

        const isPlayerChecked = this.isPlayerChecked();
        const isButtonDisabled = this.isButtonDisabled();

        const classNames = this.getClassNames(isPlayerChecked, isButtonDisabled);
        const title = this.getTitle(isPlayerChecked);

        return (
            <button
                type="button"
                className={classNames.join(' ')}
                onClick={() => ::this.onCheck(!isPlayerChecked)}
                title={title}
                disabled={isButtonDisabled}
            >
                {title}
            </button>
        );
    }
}

function mapStatesToProps(state) {
    const {filterLineupsByPlayer, lineupPlayerMap} = state;

    return {
        filterLineupsByPlayer,
        lineupPlayerMap,
    };
}

export default connect(mapStatesToProps)(FilterLineupsByPlayerAndFlex);
